// src/data/enfermedades.js
export const loadEnfermedades = async (lang = "fr") => {
  try {
    const res = await fetch(`/enfermedades/enfermedades_${lang}.json`);
    if (!res.ok) throw new Error("No se pudo cargar el archivo");

    const data = await res.json();

    // Convierte objeto plano a array de { code, name }
    const result = Object.entries(data).map(([code, name]) => ({
      code,
      name
    }));

    return result;
  } catch (err) {
    console.error(`❌ Error cargando enfermedades para '${lang}':`, err);
    return [];
  }
};
